import React from "react";

/**
 * VehicleDetailMaintenanceInspectionIcon
 *
 * Icon for vehicle maintenance and inspection costs detail. Used in VehicleDetailsList.
 */
const VehicleDetailMaintenanceInspectionIcon: React.FC<{
  className?: string;
}> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height="24"
    width="24"
    className={className}
  >
    <path
      stroke="currentColor"
      d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VehicleDetailMaintenanceInspectionIcon;
